import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from 'antd';
import SomeThingWrongPage from './SomeThingWrongPage';
import { storeBowser } from '@Stores/StoreBowser';

const SomeThingWrongModal = observer(props => {
    const { modal1Visible } = props
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {

        setShowModal(modal1Visible)

    }, [modal1Visible])

    return (
        <Modal
            centered
            visible={showModal}
            footer={null}
            closable={true}
            width={(() => {
                if (storeBowser.isDesktop()) {
                    return 840
                } else if (storeBowser.isTablet()) {
                    return 673
                } else if (storeBowser.isMobile()) {
                    return 320
                } else {
                    return 416
                }
            })()}
            wrapClassName='something-wrong--modal'
            onCancel={() => setShowModal(false)}
        >
            <SomeThingWrongPage />
        </Modal>
    );
})

export default SomeThingWrongModal;